import React from 'react';

export default ({ paymentMethod, subTotal, total }) =>
  <div className="acct-order-total">
    <div className="acct-payment-column">
      <strong>Payment Method: </strong>
      <div className="align-center">{ paymentMethod }</div>
    </div>
    <div>
      <div className="acct-payment-column"><strong>Total Offered: </strong><div className="align-center">${ total }</div></div>
    </div>
  </div>
